import { render, staticRenderFns } from "./IconExit.vue?vue&type=template&id=5b28efe3"
import script from "./IconExit.vue?vue&type=script&lang=ts"
export * from "./IconExit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports